import http from './http'
export function getConnection(email) {
  return http.post("/v1/profile/authentication/connection", { 'email': email})
}

export function authenticate(token, state) {
  return http.post("/v1/profile/authentication/passwordless/login", { token, state })
}
